import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutLoginComponent } from '@ebf/core/layouts/view/layout-login/layout-login.component';
import { LayoutAppComponent } from '@ebf/core/layouts/view/layout-app/layout-app.component';
import { isAdminGuard } from '@ebf/core/user/guards/is-admin.guard';
import { isGuestGuard } from '@ebf/core/user/guards/is-guest.guard';
import { CompleteRegistrationComponent } from '@ebf/core/user/view/complete-registration/complete-registration.component';

const routes: Routes = [
  {
    path: 'login',
    component: LayoutLoginComponent,
  },
  {
    path: 'complete-registration',
    component: CompleteRegistrationComponent,
  },
  {
    path: 'create-model',
    component: CompleteRegistrationComponent,
    data: { isCreateModel: true },
    canMatch: [isGuestGuard],
  },
  {
    path: 'model-data',
    loadChildren: () => import('./features/models/models.module').then(m => m.ModelsModule),
  },
  {
    path: '',
    component: LayoutAppComponent,
    children: [
      {
        path: 'championships',
        loadChildren: () =>
          import('./features/championships/championships.module').then(m => m.ChampionshipsModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
        canMatch: [isAdminGuard],
      },
      {
        path: 'requests',
        loadChildren: () => import('./features/requests/requests.module').then(m => m.RequestsModule),
        canMatch: [isAdminGuard],
      },
      {
        path: 'faq',
        loadChildren: () => import('./features/faq/faq.module').then(m => m.FaqModule),
      },
      {
        path: '**',
        redirectTo: 'championships',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
